import dayjs from 'dayjs';

import { DATE_KEY_FORMAT } from '@/helpers';

import { MAX_DATES_WINDOW } from '../constants';

export const getPlannerDatesWindow = (anchorDate: dayjs.Dayjs) => {
  const halfWindow = Math.floor(MAX_DATES_WINDOW / 2);
  const startDate = anchorDate.subtract(halfWindow, 'day');

  return Array.from({ length: MAX_DATES_WINDOW }, (_, i) => startDate.add(i, 'day'));
};

/**
 * Calculates buffered date period by adding buffer months before and after the given period
 */
export const calculateBufferedPeriod = (
  startDate: string,
  endDate: string,
  bufferMonths: number = 3
): { startDate: string; endDate: string } => {
  return {
    startDate: dayjs(startDate).subtract(bufferMonths, 'months').format(DATE_KEY_FORMAT),
    endDate: dayjs(endDate).add(bufferMonths, 'months').format(DATE_KEY_FORMAT),
  };
};
